import { useQuery } from '@tanstack/react-query';
import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import type { PolicyViolationLabel } from './useCreatePolicy';

export interface GovernanceIssuePolicyOption {
  id: number;
  name: string;
  violationLabel: PolicyViolationLabel;
}

export function useFetchGovernanceIssuePolicies() {
  return useQuery({
    queryKey: [api.governanceIssuePolicies],
    queryFn: () =>
      fetchWrapper.get<GovernanceIssuePolicyOption[]>(
        api.governanceIssuePolicies,
      ),
  });
}
